// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eV4t1","rootMobile":"styles_rootMobile__3qFXF"};